import React, { useEffect } from 'react'
import './App.css'
import { AppRouter } from 'router/Routes'
import LoaderContainer from 'modules/common/containers/Loader'
import CommonFeedback from 'modules/common/components/Modals/CommonFeedback'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from 'styles/global'
import useTheme from 'styles/useTheme'
import IdleTimerComponent from 'modules/common/components/IdleTimer'
import 'react-phone-input-2/lib/style.css'

const App: React.FC = () => {
  const theme = useTheme()

  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (target.tagName === 'IMG' || target.tagName === 'VIDEO') {
        event.preventDefault()
      }
    }

    document.addEventListener('contextmenu', handleContextMenu)

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AppRouter />
      <CommonFeedback />
      <LoaderContainer />
      <IdleTimerComponent />
    </ThemeProvider>
  )
}

export default App
